import { ref, watch } from 'vue';
import usePoller from './use-poller';
import { UsePollerArgs, PollingSubscription } from '@/app/shared/types/stores/user-poll.state.interface';
import attributesApi from '@/app/features/ams/attributes/attributes-service';
import { AttributeLockApiResponse, UseAttributeLockerArgs } from '@/app/shared/types/stores/use-attribute-locker-api.resp.interface';

const AttributeLockRefreshApiCall = async (_args: {
  attributeId: number;
  clientId: number;
}): Promise<AttributeLockApiResponse> => {
  return await attributesApi.refreshLockAttributeById(
    _args.clientId,
    _args.attributeId
  );
};

const useAttributeLocker = (args: UseAttributeLockerArgs) => {
  const nextPollTime = ref<number>(0);
  const pollerArgs: UsePollerArgs<AttributeLockApiResponse> = {
    pollingTimeInMS: 10000,
    firstPollingTimeInMS: args.firstPollingTimeInSeconds * 1000,
    pollingFunction: () => {
      return AttributeLockRefreshApiCall({
        attributeId: args.attributeId,
        clientId: args.clientId,
      });
    },
    //todo: check time
    renewEarlyMS: 30,
    onPollingSuccess: (t) => {
      const lockDurationSeconds = t.data.data.lockDurationSeconds;
      nextPollTime.value = lockDurationSeconds * 1000;
    },
    onPollingError: (_error: any) => {
      console.error(_error);
    },
  };
  const poller = usePoller(pollerArgs);
  watch(nextPollTime, (newValue: number) => {
    poller.setPollingTime(newValue);
  });
  let subscription: PollingSubscription;
  const pollerState = ref('INIT');

  const startSubscription = () => {
    subscription = poller.start();
    pollerState.value = 'STARTED';
  };
  const endSubscription = () => {
    subscription?.stop();
    pollerState.value = 'STOPPED';
  };

  return {
    pollerState,
    startSubscription,
    endSubscription,
  };
};
export { useAttributeLocker };
